<template>
  <PageTemplate>
    <Loader v-if="!isLoaded"/>
    <div v-else>
      <BackButton
          :label="$t('general.button.back')"
          :to="{ name: 'travelExpensesPendingAndActiveList' }"
          marginBottom="5"/>

      <h6 class="element-header">
        {{ $t('travel_expenses.title') }}
      </h6>

      <div class="row mb-4">
        <div class="col-lg-8">
          <Summary
              :travelExpenses="travelExpenses"
              @createTravelExpenses="handleFormModal"/>

          <ItemList
              :travelExpenses="travelExpenses"
              :items="items"
              @getItemData="getItemData"
              @deleteItem="handleDeleteModal"
              @submitForApproval="handleSubmitForApprovalModal"/>
        </div>
        <div class="col-lg-4 col-md-12 col-sm-12">
          <Mesagges :travelExpenses="travelExpenses"/>
        </div>
      </div>
    </div>

    <Modal
        v-model="showFormModal"
        :title="formTitle"
        :hide-cancel="true"
        :button-label="$t('general.button.save')"
        sizeModal="modal-xl"
        :hide-footer="true"
        classFooter="justify-content-center">
      <Form
          :itemData="itemData"
          :travelExpenses="travelExpenses"
          @createTravelExpenses="getTravelExpenses"
          v-model:submitForm="submitForm"/>
    </Modal>

    <ModalDelete
        v-model="showDeleteModal"
        :header="t('general.delete_item_header')"
        :onDelete="deleteItem"/>

    <ModalConfirm
        v-model="showSubmitForApprovalModal"
        :confirmationQuestion="t('general.submit_for_approval')"
        header=""
        :onConfirm="submitForApproval"/>

  </PageTemplate>
</template>

<script setup>
import travelExpensesService from '@/api/TravelExpenses';
import Loader from '@/components/Loader.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import ModalDelete from '@/components/modal/ModalDelete.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import {CloseToast, ErrorToast, SuccessToast} from '@/components/VueToast';
import router from '@/router';
import ItemList from '@/views/App/TravelExpenses/User/Details/ItemList.vue';
import Mesagges from '@/views/App/TravelExpenses/User/Details/Mesagges.vue';
import {onMounted, ref, watch} from 'vue';
import {useI18n} from 'vue-i18n';
import {useRoute} from 'vue-router';
import Modal from "@/components/modal/Modal.vue";
import Form from "@/views/App/TravelExpenses/User/Form.vue";
import Summary from "@/views/App/TravelExpenses/User/Details/Summary.vue";
import BackButton from "@/components/button/BackButton.vue";

const {t} = useI18n();
const route = useRoute();
const showDeleteModal = ref(false);
const showSubmitForApprovalModal = ref(false);
const isLoaded = ref(false);
const travelExpenses = ref({});
const itemData = ref({});
const travelExpensesId = ref(route?.params?.id);
const items = ref([]);
const showFormModal = ref(false)
const itemId = ref(null)
const submitForm = ref(false);
const formTitle = ref("")

watch(submitForm, () => {
  itemId.value = null;
  showFormModal.value = false;
  showDeleteModal.value = false;
  getTravelExpenses();
  getItems();
});

async function getTravelExpenses() {
  try {
    const {data} = await travelExpensesService.getTravelExpensesDetails(travelExpensesId.value);
    travelExpenses.value = data.data;
    formTitle.value =
        "Fahrtkosten - " +
        travelExpenses.value.year +
        ", " +
        t(`calendar.months_number_key.${travelExpenses.value.month}`);

    await getItems()
  } catch (error) {
    if (error.response?.status === 403) {
      await router.push({name: 'travelExpensesPendingAndActiveList'});
    }
    await ErrorToast(error);
  }
}

async function getItems() {
  try {
    const {data} = await travelExpensesService.getItems(travelExpensesId.value);
    items.value = data?.data
  } catch (error) {
    await ErrorToast(error);
  }
}

async function deleteItem() {
  try {
    await travelExpensesService.deleteTravelExpensesItem(itemId.value);
    showDeleteModal.value = false;
    itemId.value = null;
    await getTravelExpenses();
    SuccessToast(t('general.toasts.delete_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

async function submitForApproval() {
  try {
    await travelExpensesService.submitForApproval(travelExpensesId.value);
    await router.push({name: 'travelExpensesPendingAndActiveList'});
    showSubmitForApprovalModal.value = false;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

function getItemData(item) {
  CloseToast();
  showFormModal.value = true
  itemData.value = {...item};
  window.scrollTo({top: 0, behavior: 'smooth'});
}


function handleFormModal() {
  CloseToast();
  itemData.value = "";
  itemId.value = "";
  showFormModal.value = true;
  showDeleteModal.value = false;
  showSubmitForApprovalModal.value = false;
}

function handleDeleteModal(id) {
  CloseToast();
  itemId.value = id;
  showDeleteModal.value = true;
  showSubmitForApprovalModal.value = false;
  showFormModal.value = false;
}

function handleSubmitForApprovalModal() {
  CloseToast();
  showSubmitForApprovalModal.value = true;
  showFormModal.value = false;
  showDeleteModal.value = false;
}


onMounted(async () => {
  if (travelExpensesId.value) {
    await getTravelExpenses();
    await getItems()
  }
  isLoaded.value = true;

  CloseToast();
});

</script>

<style scoped>

</style>